// Query params related to auto-download and auto-bulk-download on the LISWP

export function getAutoDownloadParams() {
  // Return empty params on server
  if (typeof window === 'undefined') {
    return {
      autoDownload: false,
      autoDownloadSource: null,
      autoDownloadFilters: null,
      bulkDownloadBooksRiId: null as string | null,
    };
  }

  const urlParams = new URLSearchParams(window.location.search);

  const autoDownload = urlParams.get('auto') === 'download';
  const autoDownloadSource = urlParams.get('auto_download_source');
  const autoDownloadFilters = urlParams.get('bulkDownload');
  const bulkDownloadBooksRiId = urlParams.get('bulkDownloadBooksRiId');

  return {
    autoDownload,
    autoDownloadSource,
    autoDownloadFilters,
    bulkDownloadBooksRiId,
  };
}
